import { Pencil } from "lucide-react";
import { FunctionComponent, useRef, useState } from "react";

import { Button } from "../button";
import { useField } from "./utils";
import { ValidationTooltip } from "./validation-tooltip";

export function ChooseField({
  count,
  label,
  modal: Modal,
  required,
}: {
  count?: number;
  label?: string;
  modal: FunctionComponent<{ onClose: () => void }>;
  required?: boolean;
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const hiddenInputRef = useRef<HTMLInputElement>(null);
  const { isInvalid, tooltip } = useField(hiddenInputRef, count);

  const closeModal = () => {
    setModalOpen(false);
  };

  const displayValue =
    count !== undefined ? `${count} chosen` : (label ?? "Choose");

  // For validation: count > 0 means valid selection
  const validationValue = count !== undefined && count > 0 ? String(count) : "";

  return (
    <ValidationTooltip model={tooltip}>
      <input
        ref={hiddenInputRef}
        type="text"
        value={validationValue}
        onChange={() => {}}
        required={required}
        className="sr-only"
        tabIndex={-1}
        aria-hidden="true"
      />
      <Button
        variant="subtle"
        size="default"
        onClick={() => setModalOpen(true)}
        aria-invalid={isInvalid}
      >
        {displayValue}
        <Pencil className="size-4" />
      </Button>

      {modalOpen && <Modal onClose={closeModal} />}
    </ValidationTooltip>
  );
}
